// UAT environment — used by `ng build -c uat`.
// Points to staging APIs and test Cognito for local testing.

export const environment = {
	production: 			false,
	appv: 				  	'v16.2.086u',
	slideVersion:           'v16.1.1005',
	assets_base:			'https://assets.foursightonline.com/',
	admin_upload: 			'https://assets.foursightonline.com/admin-uploads/docs/',
	profileURL:				'https://aa-staging.foursightonline.com',
	assessment_admin:		'https://aa-staging.foursightonline.com/',
	lambda_pf_footer:		'https://aa-staging.foursightonline.com/',
	features_admin:			'https://aa-staging.foursightonline.com/admin',
	store:					'http://staging.foursight.flywheelsites.com/store/',
	s3_upload:				'https://assets.foursightonline.com/app',
	assessment_pdt_id:		1,
	stripe_api_key:       	'pk_test_9hSEcjrbV6OdEGolHUnWsQ9B',
	copyright_year: 		'2026',
	cognito: {
		authority: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_fpVIyXqnH',
		clientId: '47absrmgoldjv2miolgqi47jtm',
		scope: 'aws.cognito.signin.user.admin email openid profile',
		responseType: 'code',
		domain: 'https://auth-test.foursightonline.com',
		staticApiKey: '19b9cb5e3341406e8803e9ff16ac5c1ef7df714fc5e446f6df97ad9900b68c02796fda15efd24199c88a694010a5660733a3a9472efef1f21dabb67b64637fef'
	}
};
